import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

import type { ComponentProps } from 'react';

export function useSeoProps(
	props: Partial<ComponentProps<typeof NextSeo>> = {},
): Partial<ComponentProps<typeof NextSeo>> {
	const router = useRouter();

	const title = 'robio ─ developer';
	const description = "Hey 👋 I'm Roberto, a solution architect";

	return {
		title,
		description,
		canonical: `https://robio.dev/${router.asPath}`,
		openGraph: {
			title,
			description,
			site_name: 'robio',
			url: `https://robio.dev/${router.asPath}`,
			type: 'website',
			images: [
				{
					url: 'https://robio.dev/banner.png',
					alt: description,
					width: 1280,
					height: 720,
				},
			],
		},
		...props,
	};
}
